module.exports = __webpack_public_path__ + "static/media/6.da791a21.jpg";